import moment from 'moment';
import 'moment/locale/ar';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/hi';
import 'moment/locale/it';
import 'moment/locale/ja';
import 'moment/locale/ko';
import 'moment/locale/pl';
import 'moment/locale/pt-br';
import 'moment/locale/ru';
import 'moment/locale/th';
import 'moment/locale/tr';
import 'moment/locale/uk';
import 'moment/locale/vi';
import 'moment/locale/zh-cn';

import 'dayjs/locale/ar';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/hi';
import 'dayjs/locale/it';
import 'dayjs/locale/ja';
import 'dayjs/locale/ko';
import 'dayjs/locale/pl';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/ru';
import 'dayjs/locale/th';
import 'dayjs/locale/tr';
import 'dayjs/locale/uk';
import 'dayjs/locale/vi';
import 'dayjs/locale/zh-cn';

import i18n from 'i18next';
import { normalizeFormatterLocale, normalizeI18nLanguage } from '@utils/languageContract';

const MOMENT_LOCALE_BY_LANGUAGE = {
  'pt-BR': 'pt-br',
  zh: 'zh-cn',
};
const CRONSTRUE_LOCALE_BY_LANGUAGE = {
  'pt-BR': 'pt_BR',
  zh: 'zh_CN',
};

function getLanguageSource(language, fallback = 'en') {
  return language || i18n.resolvedLanguage || i18n.language || fallback;
}

export function getCurrentI18nLanguage(language, fallback = 'en') {
  return normalizeI18nLanguage(getLanguageSource(language, fallback), fallback);
}

export function getCurrentFormatterLocale(language, fallback = 'en') {
  return normalizeFormatterLocale(getLanguageSource(language, fallback), fallback);
}

export function getCurrentMomentLocale(language, fallback = 'en') {
  const canonicalLanguage = getCurrentI18nLanguage(language, fallback);

  return MOMENT_LOCALE_BY_LANGUAGE[canonicalLanguage] || canonicalLanguage;
}

export function getCurrentCronstrueLocale(language, fallback = 'en') {
  const canonicalLanguage = getCurrentI18nLanguage(language, fallback);

  return CRONSTRUE_LOCALE_BY_LANGUAGE[canonicalLanguage] || canonicalLanguage;
}

export function applyMomentLocale(language, fallback = 'en') {
  const locale = getCurrentMomentLocale(language, fallback);
  moment.locale(locale);
  return locale;
}
